import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import BarLoader from "../../../Display/Loader/BarLoader";
import generateUUID from "../../../../utils/generateUUID";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'search-program-card-skeleton';
function CardSkeleton(_ref) {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsxs("section", {
    className: cn(DISPLAY_NAME, className, 'border border-solid rounded border-med-pale-blue bg-white'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "border-b border-solid border-med-pale-blue p-4",
      children: [/*#__PURE__*/_jsx(BarLoader, {
        size: "full",
        tall: true,
        className: "mb-2"
      }), /*#__PURE__*/_jsx(BarLoader, {
        size: "full"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-4 border-b border-solid border-med-pale-blue",
      children: Array(5).fill(0).map(() => /*#__PURE__*/_jsx(BarLoader, {
        className: "mb-1",
        size: "full"
      }, generateUUID()))
    })]
  });
}
CardSkeleton.propTypes = {
  className: PropTypes.string
};
CardSkeleton.defaultProps = {
  className: ''
};
export default CardSkeleton;
//# sourceMappingURL=CardSkeleton.js.map